/**
 * This error occurs if we cannot confirm an order was cancelled due to a delay or issue on tradier's end. 
 * An example of when it could come up is, let's say a user cancels his trade plan while there is a BTO order
 * on the market. We try to cancel the trade plan (and therefore cancel the order), but after cancelling the order,
 * we get a response from Tradier saying the order is still open. This notification would then arise as we try to handle
 * the situation on the B.E
 * {
	"messageType": "alertNotification",
	"notificationId": 1645453504691,
	"notificationDetails": {"errorType":"TRADE_PLAN_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "CANNOT_CONFIRM_ORDER_CANCELLED",
	"statusDetails": {"orderId":"2"},
	"date": "2022-02-21T09:25:05.452-0500",
	"timestamp": "1645453505453"
}

 * @param {*} statusDetails 
 * @returns object with following field:
 * 1) orderId: the id of the order that we cannot determine what its current state is
 */
export function cannotConfirmOrderCancelledParser(statusDetails) {
  const parsedObj = {
    orderId: null,
  };
  if (statusDetails) {
    parsedObj.orderId = statusDetails.orderId ?? null;
  }

  return parsedObj;
}
